// Column widths are clamped so persisted or pointer-derived values cannot break the table layout.
export const MIN_COLUMN_SIZE = 80;
export const MAX_COLUMN_SIZE = 1200;

// Compact tables cap pinned columns so scrolling content keeps most of the viewport.
export const COMPACT_TABLE_WIDTH = 600;
export const PINNED_COLUMN_MAX_FRACTION = 0.4;

// Every toolbar control shares one size, in every viewport, so the row keeps a
// single rhythm and matches the right rail and the settings page header.
export const SERVER_TABLE_CONTROL_SIZE = 36;
export const SERVER_TABLE_CONTROL_ICON_SIZE = 22;

export const serverTableControlSx = {
    width: SERVER_TABLE_CONTROL_SIZE,
    height: SERVER_TABLE_CONTROL_SIZE,
    borderRadius: 1
} as const;

export const serverTableControlIconSx = {fontSize: SERVER_TABLE_CONTROL_ICON_SIZE} as const;

/** Labelled controls match the icon buttons in height but keep their intrinsic width. */
export const serverTableTextControlSx = {
    height: SERVER_TABLE_CONTROL_SIZE,
    minHeight: SERVER_TABLE_CONTROL_SIZE,
    borderRadius: 1,
    whiteSpace: 'nowrap'
} as const;
